/**
 * 법정 서류 화면의 경로 — **순수 모듈**(알림 목적지 분기 여러 자리가 같은 값을 읽게 한 벌로 둔다).
 *
 * 알림은 `resourceType: 'legal_obligation_instance'`·`resourceId: <인스턴스 id>`만 싣고 현장을 싣지
 * 않는다(서버 `legal-obligation-imminent.service.ts`) — 그래서 목적지는 인스턴스 라우트이고, 그 화면이
 * `GET /legal-documents/instances/:instanceId`로 현장을 찾아 의무 목록으로 replace 이동한다.
 *
 * 이 값을 읽는 web 자리(같은 일을 하는 경로 전수 — 2026-10-28 grep):
 *   · `components/NotificationDropdown.tsx`의 `resourceType` switch(헤더 벨)
 *   · `lib/notifications.ts`의 `getNotificationResourcePath`(알림 목록 페이지)
 *   · `components/WebSocketProvider.tsx`의 `getNavigatePath`(실시간 토스트 클릭)
 *   · `public/push-handler.js`의 `pathMap`(서비스 워커 — import할 수 없어 **리터럴 사본**이다.
 *     `__tests__/pushHandlerRouting.test.ts`가 그 값을 이 함수와 대조한다)
 *
 * ⚠️ 이 모듈은 `vi.mock`되는 `lib/notifications`·`lib/legalDocuments`와 갈라 둔다 — 그 모듈들을
 * mock하는 spec이 새 export 때문에 죽지 않게 한다.
 */

/** 알림 `resourceType` — 서버가 싣는 값 그대로 */
export const LEGAL_OBLIGATION_INSTANCE_RESOURCE_TYPE = 'legal_obligation_instance';

/**
 * 사건 등록 취소 알림의 `resourceType`(9-o) — `resourceId`가 **현장 id**다(인스턴스는 이미 지워졌다).
 * 목적지는 `legalSiteObligationsPath(siteId)`이고 같은 네 자리 + 서버 `buildNotificationUrl`이 읽는다.
 */
export const LEGAL_OBLIGATION_SITE_RESOURCE_TYPE = 'legal_obligation_site';

/** 알림 목적지 — 인스턴스 id로 현장을 찾아가는 경유 화면 */
export function legalObligationInstancePath(instanceId: string): string {
  return `/legal-documents/instances/${encodeURIComponent(instanceId)}`;
}

/** 한 현장의 의무 목록 — `obligationId`를 주면 그 행을 강조한다 */
export function legalSiteObligationsPath(siteId: string, obligationId?: string): string {
  const base = `/legal-documents/sites/${encodeURIComponent(siteId)}`;
  return obligationId ? `${base}?obligationId=${encodeURIComponent(obligationId)}` : base;
}

/**
 * 「우리 기관의 법정 의무」(②-g3 G4 조직 층) — 조직 층 인스턴스의 알림 목적지(2026-11-05 · 조직 층에도 임박 알림이 간다). 라우트 정본은
 * `App.tsx`의 `/legal-documents/organization`. 행 강조 query는 없다(그 화면은 의무 둘뿐이고 대상 줄은 이름으로 찾는다)
 */
export function legalOrganizationObligationsPath(): string {
  return '/legal-documents/organization';
}
